import React, { useState, useEffect, useCallback } from 'react';
import {
  IconButton, Grid, Typography, Button
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { debounce } from 'lodash';

// components
import { useHistory } from 'react-router-dom';
import PageTitle from '../../components/PageTitle';
import Notification from '../../utils/notification';
import DeleteDialog from '../../components/DeleteDialog';
import TableData from '../../components/TableData';
import Widget from '../../components/Widget/Widget';

import { useLayoutDispatch, toggleLoading } from '../../context/LayoutContext';
import useStyles from './styles';
import api from '../../services/api';
import { getError } from '../../utils/getResponseError';
import { dateWithHours, parseISO } from '../../utils/dateFormatter';

export default function Usuarios() {
  const history = useHistory();
  const classes = useStyles();
  const [usuarios, setUsuarios] = useState([]);
  const [openDelete, setOpenDelete] = useState(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [error, setError] = useState(null);
  const layoutDispatch = useLayoutDispatch();

  useEffect(() => {
    usuariosRequest();
  }, [page, search]);

  async function usuariosRequest() {
    toggleLoading(layoutDispatch);
    setError(null);
    try {
      const { data } = await api.get(`/usuario?pagina=${page}&nome=${search}`);
      setTotal(data.totalPaginas);
      setUsuarios(data.dados.map((item) => ({
        ...item,
        criado_em: dateWithHours(parseISO(item.criado_em)),
        atualizado_em: item.atualizado_em ? dateWithHours(parseISO(item.atualizado_em)) : 'Nenhuma atualização',
      })));
      if (page > data.totalPaginas) {
        setPage(1);
      }
    } catch (error) {
      setError(getError(error));
    }
    toggleLoading(layoutDispatch);
  }

  const handleSearch = (query) => {
    setSearch(query);
  };

  const onSearch = useCallback(
    debounce(handleSearch, 500),
    []
  );

  function handlePage(newPage) {
    if (newPage !== page) {
      setPage(newPage);
    }
  }

  function handleDeleteConfirmation(index) {
    setOpenDelete(index.toString());
  }

  function handleCancelDelete() {
    setOpenDelete(null);
  }
  function handleReload() {
    usuariosRequest();
  }

  async function handleDelete() {
    const usuario = usuarios[openDelete];
    try {
      await api.delete(`/usuario/${usuario.id_usuario}`);
      Notification({
        type: 'shipped',
        message: 'Usuário excluído com sucesso!',
        variant: 'contained',
        color: 'success',
      });
      usuariosRequest();
    } catch (error) {
      Notification({
        type: 'report',
        message: getError(error),
        variant: 'contained',
        color: 'secondary',
      });
    }
    setOpenDelete(null);
  }

  function handleEdit(index) {
    const usuario = usuarios[index];
    history.push(`/app/sistema/usuarios/cadastro/${usuario.id_usuario}`);
  }

  return (
    <>
      <DeleteDialog
        open={!!openDelete}
        handleClose={handleCancelDelete}
        handleConfirm={handleDelete}
        message="Tem certeza que deseja excluir o usuário?"
      />
      <PageTitle
        title="Usuários"
        button={(
          <IconButton
            color="primary"
            aria-label="cadastrar novo cliente"
            className={classes.addButton}
            onClick={() => history.push('/app/sistema/usuarios/cadastro')}
          >
            <AddIcon />
          </IconButton>
        )}
      />
      {error && (
        <Grid container spacing={4}>
          <Grid
            item
            xs={12}

          >
            <Widget
              disableWidgetMenu
              style={{
                textAlign: 'center',
              }}
            >
              <Typography
                variant="h6"
                color="textSecondary"
                style={{
                  textAlign: 'center'
                }}
              >
                Ocorreu um erro ao tentar listar os usuários
              </Typography>
              <Typography
                variant="p"
                color="textSecondary"
                style={{
                  textAlign: 'center'
                }}
              >
                Mensagem de erro:
                {' '}
                {error}
              </Typography>
              <br />
              <Button
                variant="contained"
                color="primary"
                style={{
                  marginTop: 50
                }}
                onClick={handleReload}
              >
                Tentar novamente
              </Button>
            </Widget>
          </Grid>
        </Grid>
      )}
      {!error && (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <TableData
              title="Usuários cadastrados"
              columns={[{
                name: 'nome',
                label: 'Nome',
                options: {
                  filter: true,
                  sort: true,
                }
              },
              {
                name: 'email',
                label: 'Email',
                options: {
                  filter: true,
                  sort: false,
                }
              },
              {
                name: 'criado_em',
                label: 'Criação',
                options: {
                  filter: true,
                  sort: false,
                }
              },
              {
                name: 'atualizado_em',
                label: 'Última atualização',
                options: {
                  filter: true,
                  sort: false,
                }
              }]}
              data={usuarios}
              search={onSearch}
              page={page}
              total={total}
              onSetPage={handlePage}
              onCloseSearch={setSearch}
              onEdit={handleEdit}
              onDelete={handleDeleteConfirmation}
              showEdit
              showDelete
              showSearch
            />
          </Grid>
        </Grid>
      )}
    </>
  );
}
